// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"content_wrapper__pmezE","mainWrapper":"content_mainWrapper__1zZ70","title":"content_title__diDOi","text":"content_text__2QZDR","subWrapper":"content_subWrapper__1xQq-"};